import React, { useState } from 'react';
import { BsPatchCheckFill } from 'react-icons/bs';
import RadialProgressAvatar from './radialProgressAvatar';


const ProfileSummaryCard = ({ profile, onViewAndUpdateResume, completionPercentage }) => {
    const [loading, setLoading] = useState(false);
    const completion = completionPercentage;
    const sqSize = 100;
    const strokeWidth = 8;
    const radius = (sqSize - strokeWidth) / 2;
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    const dashArray = radius * Math.PI * 2;
    const dashOffset = dashArray - (dashArray * completion) / 100;

    // function formatLastUpdated() {
    //     const updatedAt = profile.updated_at;
    //     let displayDate = '';
    //     if (updatedAt) {
    //         const updatedDate = new Date(updatedAt);
    //         const now = new Date();
    //         const diffMs = now - updatedDate;
    //         const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    //         if (diffDays <= 5 && diffDays >= 0) {
    //             displayDate = diffDays === 0 ? 'Today' : `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    //         } else {
    //             displayDate = updatedDate.toLocaleDateString();
    //         }
    //     }
    //     return displayDate
    // }
    function formatLastUpdated() {
  const updatedAt = profile.updated_at;
  let displayDate = '';

  if (updatedAt) {
    const updatedDate = new Date(updatedAt);
    const now = new Date();
    const diffMs = now - updatedDate;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays <= 5 && diffDays >= 0) {
      displayDate =
        diffDays === 0
          ? 'Today'
          : `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    } else {
      displayDate = updatedDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    }
  }

  return displayDate;
}


    const handleViewAndUpdateClick = async () => {
        setLoading(true);
        try {
            await onViewAndUpdateResume(profile);
            setLoading(false);
        } finally {
        }
    };

    return (
        <div className="rounded-2xl shadow-style p-2 text-center">
            <div className='w-full flex gap-2 border-b '>
   <RadialProgressAvatar
                imageUrl={profile.name}
                size={60}
                completion={completionPercentage}
                firstName={profile.first_name}
                lastName={profile.last_name}
            />
            <div className='text-left w-full overflow-auto px-2'>
                <div className='flex flex-col w-full gap-1 '>
                <h2 className="text-sm font-bold  flex items-center text-gray-333 gap-1.5">
                    {profile.first_name} {profile.last_name}
                    <BsPatchCheckFill className="mph-primary" size={14} />
                </h2>
                <p className="text-xs text-gray-999">{profile.highest_position}</p>
                <p className="text-xs w-[85%] truncate text-gray-999">{profile.email}</p>
                </div>
                  <button
                    className="text-xs font-semibold text-blue-700 mt-2  text-blue rounded-full py-1.5 transition-colors flex items-center gap-2 relative"
                    onClick={handleViewAndUpdateClick}
                    disabled={loading}
                >
                    {loading && (
                        <span className="mr-2">
                            <svg className="animate-spin h-3 w-3 text-gray-400 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                            </svg>
                        </span>
                    )}
                    {loading ? 'Loading...' : 'View profile'}
                </button>
            </div>
            
            </div>
         

            <div className=" pt-4 flex gap-2 justify-between items-center">
                <p className="text-xs font-semibold text-gray-800">
                    Last updated 
                </p>
                <p className='text-xs text-gray-999'>{formatLastUpdated()}</p>
              
            </div>
        </div>
    );
};

export default ProfileSummaryCard;